import {Fragment, ReactNode} from "react";
import {Box, HStack, Stack, Text} from "@chakra-ui/react";

/**
 * A compact, content-width card of metrics (label over value) with thin dividers — sized to its
 * contents so it can sit beside the title/description rather than as a full-width bar.
 */
export const InlineMetrics = ({stats}: {stats: {label: ReactNode; value: ReactNode}[]}) => (
  <Box bg="white" borderWidth="1px" borderColor="gray.200" rounded="lg" flexShrink={0}>
    <HStack gap={0} align="stretch">
      {stats.map((stat, i) => (
        <Fragment key={i}>
          {i > 0 && <Box w="1px" bg="gray.200" flexShrink={0} alignSelf="stretch" />}
          <Stack gap={1} px={4} py={2.5} align="start" minW={0}>
            <Text
              fontSize="2xs"
              fontWeight="600"
              letterSpacing="wider"
              textTransform="uppercase"
              color="fg.muted"
              whiteSpace="nowrap"
            >
              {stat.label}
            </Text>
            <Box fontSize="sm" fontWeight="600" color="gray.fg" whiteSpace="nowrap">
              {stat.value}
            </Box>
          </Stack>
        </Fragment>
      ))}
    </HStack>
  </Box>
);
